import Braintree from "./Braintree";

export default Braintree;
